'use strict';

var Backbone = require('backbone'),
  config = require('../../js/config'),

  CarouselCounterView = Backbone.View.extend({

    events: {
      'change .CarouselCounter-count': 'onChange',
      'click .CarouselCounter-prev': 'onPrevClick',
      'click .CarouselCounter-next': 'onNextClick'
    },

    initialize: function() {
      this.isInput = false;

      this.$count = this.$('.CarouselCounter-count');
      this.total = parseInt(this.$('.CarouselCounter-total').text());
      this.$prev = this.$('.CarouselCounter-prev');
      this.$next = this.$('.CarouselCounter-next');

      // If the counter is an input field, we need to listen to its change to update the other components
      if (this.$count.is('input[type=text]')) {
        this.isInput = true;
      }

      this.updateArrowActive();
    },

    update: function(index) {
    // If the counter is an input field, update its value, other change its content
      if (this.isInput) {
        this.$count.val(index);
      } else {
        this.$count.text(index);
      }

      this.updateArrowActive();
    },

    updateArrowActive: function() {
      var current = parseInt(this.$count.val(), 10);

      this.$prev.toggleClass(config.classes.isActive, current > 1);
      this.$next.toggleClass(config.classes.isActive, current < this.total);
    },

    // When carouel value changes
    onChange: function(ev) {
      var val = ev.currentTarget.value;

      // If the value entered is higher than the maximum or lower than 1
      if (val > this.total) {
        val = this.total;
      } else if (val < 1) {
        val = 1;
      }

      this.trigger('change', val);

    },

    onPrevClick: function(e) {
      e.preventDefault();
      this.trigger('prev');
    },

    onNextClick: function(e) {
      e.preventDefault();
      this.trigger('next');
    }

  });

module.exports = CarouselCounterView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/CarouselCounterView.js